import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { ApplicationControlStartRuleItem } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export class GzApplicationControlRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ApplicationControlStartRuleItem
> {
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert to boolean
    const statusFilterIdx = request.filters.findIndex(filter => Object.keys(filter)[0] === ColumnKeys.STATUS);
    if (statusFilterIdx !== -1) {
      request.filters[statusFilterIdx][ColumnKeys.STATUS].in = request.filters[statusFilterIdx][
        ColumnKeys.STATUS
      ].in.map(status => !!status);
    }

    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }
}
